<template>
  <div class="wrapper">
    <img class="cover rellax" data-rellax-speed="1" src="./assets/cover.png" />
    <img class="light rellax" data-rellax-speed="10" src="./assets/light.png" />
    <div id="content" ref="content" data-rellax-speed="10">
      <ProgressBar
        v-show="shouldShowProgressBar"
        :nowSection="nowSection"
        :isSticky="isSticky"
      />
      <About ref="about" id="about" class="section" :isMobile="isMobile" />
      <Preview ref="preview" id="preview" class="section" />
      <Sample ref="sample" id="sample" class="section" />
      <Info ref="info" id="info" />
      <SpecialEvent ref="special" id="special" />
    </div>
    <Cast ref="cast" id="cast" />
  </div>
</template>

<script>
import Rellax from "rellax";
import ProgressBar from "./components/ProgressBar.vue";
import About from "./components/About.vue";
import Preview from "./components/Preview.vue";
import Sample from "./components/Sample.vue";
import Info from "./components/Info.vue";
import SpecialEvent from "./components/SpecialEvent.vue";
import Cast from "./components/Cast.vue";

export default {
  name: "App",
  components: {
    ProgressBar,
    About,
    Preview,
    Sample,
    Info,
    SpecialEvent,
    Cast,
  },
  data() {
    return {
      shouldShowProgressBar: false,
      isMobile: true,
      nowSection: "",
      isSticky: false,
    };
  },
  mounted() {
    if (window.innerWidth > 768) {
      this.isMobile = false;
    }
    new Rellax(".rellax");
    // 偵測進來的時候
    const scene = this.$scrollmagic
      .scene({
        triggerElement: "#content",
        triggerHook: 0,
      })
      .on("enter leave", (e) => {
        this.shouldShowProgressBar = e.type === "enter";
      });
    // .addIndicators();
    // Add Scene to controller
    this.$scrollmagic.addScene(scene);
    // 偵測現在在哪個區塊
    this.addScene("about");
    this.addScene("preview");
    this.addScene("sample");
    this.addScene("info");
    this.addScene("special");

    // cast 出現時隱藏
    const cast = this.$scrollmagic
      .scene({
        triggerElement: `#cast`,
        triggerHook: 1,
      })
      .on("enter leave", (e) => {
        // this.shouldShowProgressBar = e.type !== "enter";
        this.isSticky = e.type === "enter";
      });
    // .addIndicators();
    this.$scrollmagic.addScene(cast);
  },
  methods: {
    addScene(id) {
      const scene = this.$scrollmagic
        .scene({
          triggerElement: `#${id}`,
          triggerHook: 0.5,
          duration: this.$refs[id]?.$el.clientHeight,
        })
        .on("enter", () => {
          this.nowSection = id;
        });
      // .addIndicators();
      this.$scrollmagic.addScene(scene);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./assets/scss/main.css";
@import url(//fonts.googleapis.com/earlyaccess/notosanstc.css);

.wrapper {
  background: #b48746;
  overflow: hidden;
  width: 100vw;
  position: relative;
  font-family: Noto Sans;
  cursor: url("./assets/mouse.png"), auto;
}

.cover {
  width: 100vw;
  /* position: fixed; */
  top: 0;
  z-index: -1;
  margin-bottom: 60vh;
}

.light {
  z-index: 10;
  width: 160vw;
  position: absolute;
  top: 20vh;
  left: -30vw;
  @media (min-width: 768px) {
    top: 50vh;
  }
}

#content {
  position: relative;
}

// .progress-bar {
//   position: sticky;
//   bottom: 0;
//   left: 5vw;
// }
</style>
